import React from 'react';
import {  Slot, router, usePathname, useSegments} from 'expo-router';
import { TopNavigation } from '../../../../components/TopNavigation/TopNavigation';
import { breatheKey, breatheSettingKey, breatheStackKey, dashboardKey, dashboardStackKey, libraryKey, libraryStackKey, privateKey } from '../../../../constants/routeKeys';
import { concatPath } from '../../../../utils/links/concatPath';
import { useAvailableDimensions } from '../../../../hooks/ui/useAvailableDimensions';
import { useHideNavigationMenu } from '../../../../hooks/navigation/useHideNavigationMenu';


export default function Layout(){
  const {height} = useAvailableDimensions();
  const route = usePathname();
  const withHeaderRight = route.includes(breatheKey);
  const segments = useSegments();
  useHideNavigationMenu();

  const goToDashboard = () => {
    router.navigate(concatPath([privateKey, dashboardStackKey, dashboardKey], -1) as string);
  };

  const goToLibrary = () => {
    router.navigate(concatPath([privateKey, libraryStackKey, libraryKey], -1) as string);
  };


  const goToHome = () => {
    if(router.canGoBack()){
      router.back();
    } else if (segments.includes(libraryStackKey)) {
      goToLibrary();
    } else {
      goToDashboard();
    }

  };

  const goToBreatheSetting = () => {

    router.navigate(concatPath([breatheStackKey,breatheSettingKey ], 1) as string);
  };

  const positionTop= height*0.06;


  return (
    <>
      <TopNavigation
        onboarding={false}
        topPosition={positionTop} horizontalPosition={30} onPressLeft={() =>
        {
          goToHome();
        }} onPressRight={() => {
          goToBreatheSetting();
        }} withHeaderRight={withHeaderRight} headerRightIcon='settings'/>
      <Slot />
    </>
  );
}
